import { Unlink } from "../../compose/Icon";

/**
 * The honest residue of "Document order".
 *
 * A note whose quote the surface can no longer find has NO position in this
 * version of the document — there is no correct place for it in a reading-order
 * list. It is neither hidden nor silently parked at the bottom as if it were the
 * last thing in the document: `sortRoots` groups these at the end and this
 * heading says, in the column, what they are.
 *
 * Rendered ONLY under document order, and only when the group is non-empty —
 * every other sort has a defined key for every note.
 *
 * ONE definition, used by both the `ReviewRail` and the `CommentGutter`: the
 * sort surface is documented as one, not two, and a divergent bucket label
 * would be exactly the kind of drift this whole fix exists to remove.
 */
export function UnanchoredHeading({ count }: { count: number }) {
  return (
    <div
      className="thread-list__group"
      data-testid="review-notes-unanchored"
      role="separator"
      aria-label={`Not anchored in this version, ${count} ${count === 1 ? "note" : "notes"}`}
    >
      <Unlink size={12} strokeWidth={1.75} aria-hidden="true" />
      <span className="thread-list__group-label">Not anchored in this version</span>
      <span className="thread-list__group-count">{count}</span>
    </div>
  );
}

/** Shared empty set — no allocation per render when the sort has no residue. */
export const NO_UNANCHORED: ReadonlySet<number> = new Set<number>();
